import classNames from "classnames";
import React, { FC } from "react";

const ArticleDivider: FC = () => {
  const line = (
    <div className={classNames("bg-gray-500", "h-[1px]", "flex-1")} />
  );

  return (
    <div className={classNames("flex", "items-center")}>
      {line}
      <p
        className={classNames(
          "px-3",
          "py-1",
          "text",
          "font-semibold",
          "text-black",
          "border-solid",
          "text-lg"
        )}
      >
        Nästa nyhet
      </p>
      {line}
    </div>
  );
};

export default ArticleDivider;
